import { useCallback, useRef } from 'react';

import { EmployerLookupHandle } from '../components/EmployerNameAndPhoneInputs';

export const useLookupRegistry = () => {
  const handlesRef = useRef<EmployerLookupHandle[]>([]);

  const registerLookup = useCallback((handle: EmployerLookupHandle) => {
    handlesRef.current.push(handle);
    return () => {
      handlesRef.current = handlesRef.current.filter((registered) => registered !== handle);
    };
  }, []);

  const finalizeLookups = useCallback(async () => {
    await Promise.allSettled(handlesRef.current.map((handle) => handle.finalize()));
  }, []);

  return { registerLookup, finalizeLookups };
};
